module.exports = __webpack_public_path__ + "490e68d09336a8397a16db16413a9942.png";